package com.dignicate.web.data.content

import com.dignicate.web.domain.LocalizedTexts

data class HeroContentDto(
    val title: LocalizedTexts,
    val subtitle: LocalizedTexts
)

data class AboutContentDto(
    val body: LocalizedTexts
)

enum class TechnologyCategoryDto {
    MOBILE,
    BACKEND,
    PROCESS
}

data class TechnologyAreaDto(
    val id: String,
    val category: TechnologyCategoryDto,
    val title: LocalizedTexts,
    val description: LocalizedTexts
)

data class ProductInfoDto(
    val id: String,
    val title: LocalizedTexts,
    val description: LocalizedTexts,
    // optional store links for content-level model
    val androidLink: String? = null,
    val iosLink: String? = null
)

data class ValueStatementDto(
    val id: String,
    val title: LocalizedTexts,
    val body: LocalizedTexts
)
